var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "059818EF-AA7A-48F9-A5C3-4D247CB305A6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.303144182
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manager-|-Assign-Audits-All",
    transform: "translate(-1577.000000, -197.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1591.57627,210.160855 L1596.72881,215.290214 C1597.0904,215.650169 1597.0904,216.370079 1596.72881,216.730034 C1596.36723,217.089989 1595.64407,217.089989 1595.28249,216.730034 L1590.12994,211.600675 C1586.9661,214.12036 1582.26554,213.850394 1579.37288,210.880765 C1576.20904,207.731159 1576.20904,202.511811 1579.37288,199.362205 C1582.53672,196.212598 1587.77966,196.212598 1590.9435,199.362205 C1593.92655,202.331834 1594.10734,206.92126 1591.57627,210.160855 L1591.57627,210.160855 Z M1589.21978,209.21978 C1591.59341,206.846154 1591.59341,203.153846 1589.21978,200.78022 C1586.84615,198.406593 1583.15385,198.406593 1580.78022,200.78022 C1578.40659,203.153846 1578.40659,206.846154 1580.78022,209.21978 C1583.15385,211.593407 1586.84615,211.593407 1589.21978,209.21978 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.71080cb75b70fa9f52cb5a85035095d2.svg";
export { ForwardRef as ReactComponent };